<div class="form-block">
    <form [formGroup]="addRecipientForm">
        <div fxLayout="row" fxLayoutGap="10px" fxLayout.lt-md="column">
            <div fxFlex="30" fxFlex.lt-md="100">
                <static-dictionary-select-ctrl [settings]="{fxFill:true}"
                    [caption]="'claims-center.claimMessages.recipientRole'" [formControlName]="'recipientRole'"
                    [staticDictionaryName]="'recipientRole'" [orderById]="true" [allowedValuesLimitation]="allowedRecipientRoles"
                    (valueChangeEvent)="recipientRoleChanged($event)"></static-dictionary-select-ctrl>
            </div>
            
                <div *ngIf="contactRecipientHasData" fxFlex="30" fxFlex.lt-md="100">
                    <text-input-ctrl [caption]="'claims-center.claimMessages.recipientInfo'"
                        [formControlName]="'recipientInfo'" [settings]="{fxFill:true}">
                    </text-input-ctrl>
                </div>

                <div *ngIf="contactRecipientHasData"  fxFlex="20" fxFlex.lt-md="100">
                    <masked-text-input-ctrl [caption]="'claims-center.claimMessages.recipientContact'"
                        [formControlName]="'recipientContact'" [settings]="{format:'000 000 000',fxFill:true}">
                    </masked-text-input-ctrl>
                </div>
                <div *ngIf="contactRecipientHasData"  fxFlex="20" fxFlex.lt-md="100">
                    <button kendoButton [primary]="true"
                        (click)="addRecipient()">{{'claims-center.claimMessages.addRecipient' |
                        translate}}</button>
                </div>
                <div *ngIf="!contactRecipientHasData && addRecipientForm.controls.recipientRole.value > 0 && !loadingRecipientData;" 
                    class="error-label" fxFlex="60" fxFlex.lt-md="100" fxLayoutAlign="center center">
                    {{'claims-center.claimMessages.noRecipientData' | translate}}
                </div>

                <app-loading-panel [isLoading]="loadingRecipientData"></app-loading-panel>
            
        </div>

          <!-- display info about not enabled user-->
          <div fxLayoutGap="5" fxLayout="column" *ngIf="contactRecipientHasData && !loadingRecipientData 
          && addRecipientForm.controls.isDisabledPortalUser.value">
              <h4 class="error-label">{{'claims-center.claimMessages.userAssociatedWithRecipientIsInactive' | translate}}</h4>
              </div>
    </form>
</div>

<div class="form-block">

    <form [formGroup]="composeMessageForm">
        <div fxLayout="column" fxLayoutGap="10px">

            <div fxLayout="column">
                <div>
                    <strong *ngIf="!composeMessageForm.controls.recipients.value?.length">
                        {{'claims-center.claimMessages.noRecipients' | translate}}</strong>
                </div>

                <div class="recipient-line" *ngFor="let recipient of composeMessageForm.controls.recipients.value"
                    fxLayoutGap="5px">
                    <kendo-icon [name]="'delete'" (click)="removeRecipient(recipient)"></kendo-icon>
                    <span>{{recipient.recipientRole | staticDictionaryCaption:'recipientRole' |async }}
                        - {{recipient.recipientInfo}}
                        - <strong>{{recipient.recipientContact}}</strong></span>

                </div>
            </div>

            <div fxFill fxLayout="row" fxLayoutGap="10">
                <div fxFlex="95">
                    <text-input-ctrl [caption]="'claims-center.claimMessages.title'" [formControlName]="'title'"
                        [settings]="{fxFill:true}">
                    </text-input-ctrl>
                </div>
                <div fxFlex="5" fxLayoutAlign="center end">
                    <button type="button" kendoButton (click)="chooseTemplate()" icon="search"> </button>
                </div>
            </div>

            <textarea-input-ctrl [caption]="'claims-center.claimMessages.contentText'" [formControlName]="'contentText'"
                [settings]="{fxFill:true,rows:10}"></textarea-input-ctrl>
            {{'claims-center.claimMessages.smsCharsCount' |  translate}} : {{charsCount()}}
        </div>
    </form>
</div>
<kendo-dialog-actions>
    <button kendoButton [primary]="true" (click)="send()">{{'claims-center.claimMessages.sendMessage' |
        translate}}</button>
</kendo-dialog-actions>

<div kendoDialogContainer #composeSmsDialog></div>